/*
 * @Author: muqing
 * @Date: 2024-08-29 15:22:34
 * @LastEditors: muqing
 * @LastEditTime: 2024-09-10 15:50:46
 * @Description: 
 */
/*
 * @Author: monai
 * @Date: 2020-06-28 15:50:14
 * @LastEditors: muqing
 * @LastEditTime: 2024-08-29 16:44:16
 */
import { reactive, App } from 'vue';
import tsxImage from './components/image';
import provide_loading from './provide/loading/provideFunc';
import provide_toast from './provide/toast/provideFunc';
import getCountryCode from './tools/getCountryCode';
import getLangText from './tools/getLangText';
import mixin_index from './mixin/mixinIndex';
import HttpClient from './tools/getHttpClient'

export default {
    globalMixin(app: App, parameter){
        mixin_index(app, parameter);
    },
    globalProvide(app: App, {activityId, reactiveText, countryCode, debuggerOptions, moduleVersion, componentConfig}: DevelopToolShare.InitParams){
        //  ajax loading
        app.provide('TOOL_loading', provide_loading(Boolean(debuggerOptions?.loading), moduleVersion?.loading ));
        //  toast
        app.provide('TOOL_toast', provide_toast(moduleVersion?.toast, componentConfig?.toast));
        //  httpclient 注入
        app.provide('TOOL_httpClient', <INJECT_httpClient>HttpClient);
        //  TEXT 文案
        app.provide('TOOL_TEXT', reactiveText);
        //  当前 countryCode
        app.provide('TOOL_countryCode', countryCode);
    },
    globalComponent(app: App, parameter: DevelopToolShare.InitParams){
        // 全局 uiImg 组件
        app.component('uiImg', tsxImage(parameter));
    },
    init(app: App, parameter: DevelopToolShare.InstallParams):DevelopToolShare.InitParams{
        //  文案动态响应数据
        let reactiveText = reactive<DevelopToolShare.ReactText>([]);
        //  国家码、parameter 中包含 countryCode 参数，则返回 countryCode。
        let countryCode = getCountryCode(app, parameter.countryCode);
        //  参数赋值：默认使用 useAjaxText 指定国家码
        let paramsAssignment: DevelopToolShare.InstallParams = Object.assign({}, {countryCode, useAjaxText: true}, parameter);
        //  文案初始化
        getLangText(app, {...paramsAssignment, reactiveText});

        return {...paramsAssignment, reactiveText};
    },
    install(app: App, parameter: DevelopToolShare.InstallParams){
        //  初始化之后的参数
        let initParameter = this.init(app, parameter);
        //  全局注入
        this.globalProvide(app, initParameter);
        //  全局组件
        this.globalComponent(app, initParameter);
        //  全局混合
        this.globalMixin(app, initParameter)
    }
}
